// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/img/CIUDAD_ENCANTADA_BACKGROUND.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Section-presentacion {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-color: #e5e5e5;
  background-size: cover;
  background-position: center;
  min-height: 902px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (max-width: 900px) {
  .Section-presentacion {
    min-height: auto;
    padding: 70px 0;
  }
}
.Section-presentacion .imageDispositivos {
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.Section-presentacion .gripgap {
  grid-gap: 50px;
}
.Section-presentacion .visible2 {
  display: none;
}

@media screen and (max-width: 1000px) and (min-width: 500px) {
  .Section-presentacion {
    height: 1100px;
  }
}
@media screen and (max-width: 1000px) and (min-width: 100px) {
  .Section-presentacion .visible {
    display: none;
  }
  .Section-presentacion .visible2 {
    display: inline;
  }
}`, "",{"version":3,"sources":["webpack://./src/Sections/Presentacion/Presentacion.scss"],"names":[],"mappings":"AAEA;EACE,yDAAA;EACA,yBAAA;EACA,sBAAA;EACA,2BAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AADF;AAGE;EAVF;IAWI,gBAAA;IACA,eAAA;EAAF;AACF;AAEE;EACE,2BAAA;EACA,sBAAA;EACA,4BAAA;AAAJ;AAKE;EACE,cAAA;AAHJ;AAME;EACE,aAAA;AAJJ;;AAQA;EACE;IACE,cAAA;EALF;AACF;AAQA;EAEI;IACE,aAAA;EAPJ;EAUE;IACE,eAAA;EARJ;AACF","sourcesContent":["@import \"~/src/utils/scss/index.scss\";\n\n.Section-presentacion {\n  background-image: url($Presentacion_Background);\n  background-color: #e5e5e5;\n  background-size: cover;\n  background-position: center;\n  min-height: 902px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  @media (max-width: 900px) {\n    min-height: auto;\n    padding: 70px 0;\n  }\n\n  .imageDispositivos {\n    background-position: center;\n    background-size: cover;\n    background-repeat: no-repeat;\n\n    // height: 100%;\n  }\n\n  .gripgap {\n    grid-gap: 50px;\n  }\n\n  .visible2 {\n    display: none;\n  }\n}\n\n@media screen and (max-width: 1000px) and (min-width: 500px) {\n  .Section-presentacion {\n    height: 1100px;\n  }\n}\n\n@media screen and (max-width: 1000px) and (min-width: 100px) {\n  .Section-presentacion {\n    .visible {\n      display: none;\n    }\n\n    .visible2 {\n      display: inline;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
